/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    '請向團隊或管理員尋求支援。',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    '我們無法擷取此搜尋的任何結果',
};
